import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import WarehouseListComponent from "components/Warehouse/list"
import {
  deleteWarehouse,
  exportWarehouse,
  getWarehouses,
} from "store/warehouse/warehouse-action"
import SAlert from "components/Alert"

const WarehouseList = () => {
  const dispatch = useDispatch()
  const { data, error, loading, exportStatus } = useSelector(
    state => state.warehouse
  )
  const [deleteModal, setDeleteModal] = useState(false)
  const [warehouse, setWarehouse] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  // Handle warehouse deletion and close the delete modal
  // Dispatch delete action for the selected warehouse
  // Close the delete modal
  const handleDeleteFunc = data => {
    if (warehouse) {
      dispatch(deleteWarehouse(warehouse.id))
    }
    setDeleteModal(false)
  }

  // Set the warehouse to be deleted and open the delete modal
  // Store the selected warehouse for deletion
  // Open the delete confirmation modal
  const onClickDelete = data => {
    setWarehouse(data)
    setDeleteModal(true)
  }

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(getWarehouses(link.url, pageNumber, according, search))
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // fetch new Provider Distribution Action Requests based search entered
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(getWarehouses(undefined, undefined, undefined, search))
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  // fetch new Provider Distribution Action Requests based page number or according changes
  useEffect(() => {
    dispatch(getWarehouses(undefined, pageNumber, according, search))
  }, [pageNumber, according, dispatch])

  const onExportBtnClick = () => {
    dispatch(exportWarehouse(search))
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />

      {/* Component Tilte  */}
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Warehouse"} />
      {/* Warehouse list component  */}
      <WarehouseListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default WarehouseList
